import { OrderStatusEnum } from "@src/features/order/entities";

export const ALL_ORDERS = "all";
export const ALL_HUBS = "all";

export enum DatePreset {
  ALL_TIME = "all_time",
  TODAY = "today",
  YESTERDAY = "yesterday",
  LAST_7_DAYS = "last_7_days",
  LAST_30_DAYS = "last_30_days",
  THIS_MONTH = "this_month",
  CUSTOM = "custom",
}

export interface OrderFilters {
  orderTypes: OrderStatusEnum[];
  hubIds: number[];
  datePreset: DatePreset;
  customStart: string | null;
  customEnd: string | null;
}
